import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, props } from '@ngrx/store';
import {
  GetSessionSummaryResponse,
  PayOnAccountPaymentPreviewV1Response,
  PaymentAccount,
  PaymentRulesResponseV1,
  TransactionAuthorizationResult,
} from '@arc/unified-payments-frontend/shared-payment';

// BTPAY-7254: dispatched by the Wallet "Back" cold-load landing page (pay-on-account-domestic's
// payment-receipt component). Own actions throughout (no shared SessionActions/
// BtPayPaymentInformationActions dispatches) so this cold-load path can't cause side effects
// in the live checkout flow — mirroring POI's payment-receipt component.
export const PoaPaymentReceiptComponentActions = createActionGroup({
  source: 'POA Payment Receipt Component',
  events: {
    Initialized: props<{ sessionId: string }>(),
    'Load Session Summary Success': props<{
      payload: GetSessionSummaryResponse;
    }>(),
    'Load Session Summary Error': props<{ error: HttpErrorResponse }>(),
    'Selected Payment Account Loaded': props<{
      selectedPaymentAccount: PaymentAccount;
    }>(),
    'Update Transaction Authorization Results': props<{
      transactionAuthorizationResult: TransactionAuthorizationResult[];
      transactionReference: string;
    }>(),
    'Load Payment Preview Success': props<{
      payload: PayOnAccountPaymentPreviewV1Response;
    }>(),
    'Load Payment Preview Error': props<{ error: HttpErrorResponse }>(),
    'Load Payment Rules Success': props<{
      payload: PaymentRulesResponseV1;
    }>(),
    'Load Payment Rules Error': props<{ payload: HttpErrorResponse }>(),
    'Payment Accounts Loaded': props<{
      paymentAccounts: PaymentAccount[];
    }>(),
  },
});
